import { render, staticRenderFns } from "./company-avatar.vue?vue&type=template&id=2b23631c&scoped=true&"
import script from "./company-avatar.vue?vue&type=script&lang=ts&"
export * from "./company-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./company-avatar.vue?vue&type=style&index=0&id=2b23631c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23631c",
  null
  
)

export default component.exports